module.exports = __webpack_public_path__ + "static/media/bottom_banner_10_1.d529cae1.png";